export const generateRandomKey = (length: number): number => {
  return Math.floor(Math.random() * 10 ** length)
}
